import cn from "classnames";
import { useMemo } from "react";
import { ColumnProps } from "./types";
import { createClassNames } from "./utils";
import styles from "./styles.module.scss";

export const Col = ({
  width,
  offset,
  className,
  children,
  dataTestId,
}: ColumnProps) => {
  const columnClassNames = useMemo(
    () => createClassNames({ width, offset }, styles),
    [width, offset]
  );

  return (
    <div
      className={cn(styles.column, columnClassNames, className)}
      data-test-id={dataTestId}
    >
      {children}
    </div>
  );
};
